const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M18.78 5.22a.75.75 0 0 1 .17.263l.048.221.002.047v10.252a.751.751 0 0 1-1.503 0V7.564L6.352 18.71a.751.751 0 0 1-1.062-1.062L16.435 6.502H7.997a.751.751 0 0 1 0-1.502h10.254a.75.75 0 0 1 .529.22"/></svg>';
export {
  a as w
};
